// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"YI-z","smallCardRow":"ZI-z","largeCardRow":"_I-z","productSearchRow":"aJ-z","curatedRow":"bJ-z"};